'use client'
import { MainErrorPage } from '@/components'

export default function Error() {
  return <MainErrorPage/>
}
